<template>
  <div class="dollar-app-section">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <h4 class="client">Proyecto personal</h4>
          <h1 class="title">
            {{ $t("dolar.title") }}
          </h1>
          <p class="description">
            {{ $t("dolar.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              API
              <ul class="menu-list">
                <li class="bullet wow animate__animated animate__backInLeft">
                {{ $t("dolar.bullet1") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet2") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet3") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet4") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet5") }}
                </li>
              </ul>
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              APP
              <ul class="menu-list">
                <li class="bullet wow animate__animated animate__backInLeft">
                {{ $t("dolar.bullet6") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet7") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet8") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet9") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("dolar.bullet10") }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img class="app-image" src="@/assets/dolar.png" alt=""/>
          <!-- <div class="store-icons is-hidden-mobile">
            <a
              href="https://play.google.com/store/apps/details?id=com.xubio.android&hl=es"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="@/assets/playstore.png" alt="" class="demo" />
            </a>
            <a
              href="https://apps.apple.com/us/app/xubio/id1410352503"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="@/assets/image10.png" alt="" class="demo" />
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DollarNotifier",
  components: {},
};
</script>
<style lang="scss" scoped>
div.dollar-app-section {
  background-color: #223543;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 3rem;

  div.columns {
    height: 100%;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      font-weight: bold;
      color: gray;
    }

    h1.title {
      font-family: "Raleway";
      color: #fff;
    }

    p.description {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #e5e5e5;
    }

    ul {
      font-family: "Raleway";
      list-style: inside;
      color: #cccccc;

      li {
        text-align: left;
        margin: 0.5rem 0;
      }
    }
  }

  div.multimedia-container {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2rem;

    img.app-image {
      height: auto;
      max-width: 80%;

      @media (min-width: 600px) {
        max-height: 68vh;
        max-width: 28rem;
      }
    }

    div.store-icons {
      background: transparent;
      img {
        height: 3rem;
        margin: 0.6rem;
      }
    }

    @media (max-width: 700px) {
      img.app-image {
        max-width: 80%;
      }
    }
  }
}
</style>
